import React from 'react';
import './EnhancedLogo.css';
import logoImage from '../assets/logo-no-bg.png';

function EnhancedLogo({ size = 'medium' }) {
  return (
    <div className={`enhanced-logo ${size}`}>
      <div className="logo-glow-effect">
        <div className="rotating-border"></div>
      </div>
      <div className="logo-wrapper">
        <img src={logoImage} alt="CodersPing InfoTech" className="enhanced-logo-image" />
        <div className="shine-effect"></div>
      </div>
      <div className="logo-particles">
        <span className="particle particle-1"></span>
        <span className="particle particle-2"></span>
        <span className="particle particle-3"></span>
        <span className="particle particle-4"></span>
      </div>
    </div>
  );
}

export default EnhancedLogo;
